// @core/api/endpoints/webhook/update_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EndpointResponse,
  UpdateEndpointRequest,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Update webhook endpoint
 * Updates the webhook endpoint configuration. You can change the URL, subscribed event types, or metadata.
 */
export async function UpdateEndpoint(
  endpoint_id: string,
  data: UpdateEndpointRequest,
  options?: RequestOptions
): Promise<EndpointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.put<EndpointResponse>(requestPath, data, requestOptions);
}
